import type { AxiosError } from 'axios';
import type { ApiError } from '@/types';

export function buildQueryString(
  params: Record<string, string | number | undefined | null>,
): string {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  });

  return searchParams.toString();
}

export function extractErrorMessage(
  error: unknown,
  defaultMessage: string = 'An error occurred',
): string {
  if (isAxiosError<ApiError>(error) && error.response?.data?.message) {
    if (Array.isArray(error.response.data.message)) {
      return error.response.data.message.join(', ');
    }
    return error.response.data.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return defaultMessage;
}

function isAxiosError<T>(error: unknown): error is AxiosError<T> {
  return (error as AxiosError).isAxiosError !== undefined;
}
